import React from "react";

const SvgClapperboard = props => (
  <svg viewBox="0 0 64 64" {...props}>
    <path
      d="M62 54v4c0 2.21-1.79 4-4 4H6c-2.21 0-4-1.79-4-4v-4h20v2c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-2h20z"
      fill="#838f9b"
    />
    <path
      d="M42 54v2c0 1.1-.9 2-2 2H24c-1.1 0-2-.9-2-2v-2h20zM32 18h-3.75l2.24-.94 5.26-2.22 2-.84H56c2.21 0 4 1.79 4 4v36h-4V19c0-.55-.45-1-1-1H32zM21.25 14L12 18H9c-.55 0-1 .45-1 1v35H4V18c0-2.21 1.79-4 4-4h13.25z"
      fill="#ccd1d9"
    />
    <path
      d="M56 19v35H8V19c0-.55.45-1 1-1h3v26h10l.16-.08C23.96 47.53 27.69 50 32 50s8.04-2.47 9.84-6.08L42 44h10V18h3c.55 0 1 .45 1 1z"
      fill="#69d6f4"
    />
    <path
      d="M52 24v20H42l-.16-.08A10.97 10.97 0 0 0 43 39c0-6.08-4.92-11-11-11s-11 4.92-11 11c0 1.77.42 3.44 1.16 4.92L22 44H12V24h40z"
      fill="#e6e9ed"
    />
    <path
      fill="#969faa"
      d="M47.98 2.44l-1.71 7.97-5.26 2.22 1.69-7.91zM32.15 9.29L37.43 7l-1.68 7.84-5.26 2.22zM26.88 11.57L25.5 18h-4.79l.89-4.15zM52 18v6h-2l-6-6zM44 24h-6l-6-6h6zM26 18l6 6h-6l-6-6h5.5zM14 18l6 6h-8v-6z"
    />
    <path
      fill="#ff826e"
      d="M26 24h-6l-6-6h6zM28.25 18H32l6 6h-6l-6-6zM50 24h-6l-6-6h6zM49 2l3 6-5.73 2.41 1.71-7.97zM37.43 7l5.27-2.28-1.69 7.91L37.75 14l-2 .84zM32.15 9.29l-1.66 7.77-2.24.94H25.5l1.38-6.43zM21.25 14l.35-.15-.89 4.15H12z"
    />
    <path
      d="M43 39c0 1.77-.42 3.44-1.16 4.92C40.04 47.53 36.31 50 32 50s-8.04-2.47-9.84-6.08A10.97 10.97 0 0 1 21 39c0-6.08 4.92-11 11-11s11 4.92 11 11z"
      fill="#ffeaa7"
    />
    <path fill="#ff826e" d="M37 39l-8 4v-8z" />
    <g>
      <path d="M61 53V18c0-2.757-2.243-5-5-5H42.702l10.67-4.493-3.9-7.801L21.043 13H8c-2.757 0-5 2.243-5 5v35H1v5c0 2.757 2.243 5 5 5h52c2.757 0 5-2.243 5-5v-5h-2zm-5-38c1.654 0 3 1.346 3 3v35h-2V19c0-1.103-.897-2-2-2H33.202l4.75-2H56zM23 55h18v1c0 .551-.449 1-1 1H24c-.551 0-1-.449-1-1v-1zM9 53V19h2v26h10.624c2.079 3.581 5.946 6 10.376 6s8.297-2.419 10.376-6H53V19h2v34H9zm31.139-41.091l-3.011 1.268 1.17-5.459 3.02-1.306-1.179 5.497zm3.433-6.472l3.02-1.306L45.4 9.694l-3.012 1.268 1.184-5.525zm-8.693 8.687l-3.011 1.268 1.156-5.393 3.02-1.306-1.165 5.431zM32 49c-5.514 0-10-4.486-10-10s4.486-10 10-10 10 4.486 10 10-4.486 10-10 10zm0-22c-6.617 0-12 5.383-12 12 0 1.404.255 2.747.7 4H13V25h38v18h-7.7c.445-1.253.7-2.596.7-4 0-6.617-5.383-12-12-12zm-.414-8l4 4h-3.172l-4-4h3.172zm-6 0l4 4h-3.172l-4-4h3.172zm-6 0l4 4h-3.172l-4-4h3.172zM13 19h.586l4 4H13v-4zm38 4h-.586l-4-4H51v4zm-7.414-4l4 4h-3.172l-4-4h3.172zm-6 0l4 4h-3.172l-4-4h3.172zm-7.967-2.662L28.047 17h-1.31l1.012-4.721 3.02-1.306-1.15 5.365zM24.691 17h-2.74l.523-2.44 3.02-1.306L24.691 17zm-4.785 0h-3.073l3.387-1.465L19.906 17zm30.722-9.507l-2.98 1.255 1.082-5.05 1.898 3.795zM5 18c0-1.654 1.346-3 3-3h8.418l-4.625 2H9c-1.103 0-2 .897-2 2v34H5V18zm56 40c0 1.654-1.346 3-3 3H6c-1.654 0-3-1.346-3-3v-3h18v1c0 1.654 1.346 3 3 3h16c1.654 0 3-1.346 3-3v-1h18v3z" />
      <path d="M7 57h2v2H7zM11 57h2v2h-2zM15 57h2v2h-2zM28 33.382v11.236L39.236 39 28 33.382zm2 3.236L34.764 39 30 41.382v-4.764z" />
    </g>
  </svg>
);

export default SvgClapperboard;